import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/useHttp";

export const getEmployees = createAsyncThunk("employees/getAll", async () => {
  const { request } = useHttp();
  return await request({
    url: "/blog/employee/list/",
  });
});

export const getDiscount = createAsyncThunk("discount/get", async () => {
  const { request } = useHttp();
  return await request({
    url: "/blog/sail/list/",
  });
});
